import React from "react";
import { NavLink, Link } from "react-router-dom";
import Select from "react-select";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/css/OverlayScrollbars.css";

class PersonalDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: true,
    };
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <section className="cmx-personalDetails-page">
        <section className="p-head">
          <h2>
            Personal Details <span>* Required</span>
          </h2>
        </section>
        {/* Personal form > start */}
        <section className="p-form-blk">
          <aside className="form-group">
            <aside className="form-inner">
              <input
                type="text"
                placeholder="First Name*"
                autoComplete="off"
                name="firstname"
                onChange={(e) => this.props.NameOnChange(e)}
                onBlur={this.props.fnOnblur}
                value={this.props.state.firstname}
                maxLength="20"
              />
            </aside>
            <p className="error-msg">{this.props.state.fnErrorMsg}</p>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input
                type="text"
                placeholder="Last Name*"
                autoComplete="off"
                name="lastname"
                onChange={(e) => this.props.NameOnChange(e)}
                onBlur={this.props.lnOnblur}
                value={this.props.state.lastname}
                maxLength="30"
              />
              <p className="error-msg">{this.props.state.lnErrorMsg}</p>
            </aside>
          </aside>
          <aside className="form-group w-100">
            <aside className="form-inner">
              <input
                type="email"
                placeholder="Email Address*"
                autoComplete="off"
                name="signUpEmailValue"
                onChange={(e) => this.props.signUp_emailOnchange(e)}
                onBlur={this.props.signUp_emailOnblur}
                value={this.props.state.signUpEmailValue}
                readOnly={this.props.state.memberIDReadOnly && true}
                className={this.props.state.memberIDReadOnly && "readonlyClass"}
              />
            </aside>
            <p className="error-msg">{this.props.state.emailErrorMsg}</p>
          </aside>
          {this.props.state.memberIDReadOnly == false && (
            <aside className={`form-group password-policy ${this.props.state.focusClass ? "policy-show" : ""} ${this.props.state.ua_pwdEyeIcon ? "show" : ""}`}>
              <aside className="form-inner">
                <input
                  type={`${this.props.state.ua_pwdEyeIcon ? "text" : "password"}`}
                  placeholder="Password*"
                  autoComplete="off"
                  name="signUpPasswordValue"
                  onChange={this.props.signUp_PasswordOnchangeFun}
                  onBlur={this.props.ua_passwordPolicyBlur}
                  onFocus={this.props.ua_passwordPolicyFocus}
                  value={this.props.state.signUpPasswordValue}
                  required
                  maxLength="20"
                />
                <span onClick={(e) => this.props.ua_eyeIcon("ua-pwd")} className="eye-icon">
                  &nbsp;
                </span>
                <aside className="pcy-tooltip">
                  <ul>
                    <li>
                      <p>
                        Contains a minimum of <strong>8 characters.</strong>
                      </p>
                    </li>
                    <li>
                      <p>
                        Include at least one number and <strong>one symbol.</strong> Use any symbol except <strong>: and /</strong>
                      </p>
                    </li>
                    <li>
                      <p>
                        Include both lower and upper case <strong>letters.</strong>
                      </p>
                    </li>
                    <li>
                      <p>
                        The password cannot be same as the last <strong>3 passwords.</strong>
                      </p>
                    </li>
                  </ul>
                </aside>
              </aside>
              <p className="error-msg">{this.props.state.signUp_PasswordErrorMsgSH}</p>
            </aside>
          )}
          {this.props.state.memberIDReadOnly == false && (
            <aside className={`form-group ${this.props.state.ua_cPwdeyeIcon ? "show" : ""}`}>
              <aside className="form-inner">
                <input
                  type={`${this.props.state.ua_cPwdeyeIcon ? "text" : "password"}`}
                  placeholder="Confirm Password*"
                  autoComplete="off"
                  name="signUpConfirmPasswordValue"
                  onChange={this.props.signUp_ConfirmPasswordOnchangeFun}
                  onBlur={this.props.signUp_ConfirmPasswordPolicyBlur}
                  value={this.props.state.signUpConfirmPasswordValue}
                  maxLength="20"
                />
                <span onClick={(e) => this.props.ua_eyeIcon("ua-cpwd")} className="eye-icon">
                  &nbsp;
                </span>
              </aside>
              <p className="error-msg">{this.props.state.signUp_ConfirmPasswordErrorMsgSH}</p>
            </aside>
          )}
          <aside className="form-group">
            <aside className="form-inner">
              <span className="countryCodeSpan">+1</span>
              <input
                type="tel"
                placeholder="Cell Phone Number*"
                autoComplete="off"
                name="signUpMobileValue"
                onChange={(e) => this.props.signUp_mobileOnchangeFun(e)}
                onBlur={(e) => this.props.signUp_mobileBlur(e)}
                value={this.props.state.signUpMobileValue}
                // maxLength="12"
                className='mobileNumberField'
              />
            </aside>
            <p className="error-msg">{this.props.state.mobileErrorMsg}</p>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input
                type="tel"
                placeholder="Home Phone Number"
                autoComplete="off"
                name="signUpHomeMobileValue"
                onChange={(e) => this.props.signUp_mobileOnchangeFun(e)}
                value={this.props.state.signUpHomeMobileValue}
                // maxLength="12"
              />
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input type="text" placeholder="Address 1" autoComplete="off" name="address1" onChange={this.props.ua_addressOnchange} value={this.props.state.address1} maxLength={60} />
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input type="text" placeholder="Address 2" autoComplete="off" name="address2" onChange={this.props.ua_addressOnchange} value={this.props.state.address2} maxLength={60} />
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input type="text" placeholder="City" autoComplete="off" name="cityValue" onChange={this.props.ua_addressOnchange} value={this.props.state.cityValue} maxLength={30} />
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <Select
                value={this.props.state.hpn_selectStateValue}
                onChange={this.props.us_hpnStateOnchange}
                options={this.props.state.stateJson}
                isSearchable={false}
                placeholder={this.props.state.loginAPI != "" ? this.props.state.loginAPI.additionaldetails.state : "State"}
                // defaultValue={this.props.state.stateValue[0]}
              />
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <input
                // type="tel"
                type="text"
                placeholder="ZIP Code*"
                autoComplete="off"
                name="zipCode"
                onChange={this.props.ua_zipCodeOnchange}
                onBlur={this.props.ua_zipCodeOnBlur}
                value={this.props.state.zipCode}
                maxLength="6"
              />
            </aside>
            <p className="error-msg">{this.props.state.zipErrorMsg}</p>
          </aside>
          <aside className="form-group birthday-blk">
            <aside className="form-inner">
              <aside className="lft">
                <p>Birthday*</p>
              </aside>
              {this.props.state.loginAPI != "" && this.props.state.loginAPI.additionaldetails.dateOfBirth != null ? (
                <aside className="rgt readonly-birthday">
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="MM*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.dateOfBirth.split("/")[0]} readOnly />
                    </aside>
                  </aside>
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="DD*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.dateOfBirth.split("/")[1]} readOnly />
                    </aside>
                  </aside>
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="YYYY*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.dateOfBirth.split("/")[2]} readOnly />
                    </aside>
                  </aside>
                </aside>
              ) : (
                <aside className="rgt">
                  <aside className="month-dropdown">
                    <Select
                      value={this.props.state.ua_birthMonthSelectValue}
                      onChange={this.props.ua_birthMonthOnchange}
                      options={this.props.month}
                      isSearchable={false}
                      placeholder="MM"
                      // readOnly={this.props.state.memberIDReadOnly && true}
                      // className={this.props.state.memberIDReadOnly && 'readonlyClass'}
                      // menuIsOpen={this.state.menuIsOpen}
                    />
                  </aside>
                  <aside className="date-dropdown">
                    <Select
                      value={this.props.state.ua_DateSelectValue}
                      onChange={this.props.ua_dateOnchange}
                      options={this.props.date}
                      isSearchable={false}
                      placeholder="DD"
                      // menuIsOpen={this.state.menuIsOpen}
                    />
                  </aside>
                  <aside className="year-dropdown">
                    <Select value={this.props.state.ua_YearSelectValue} onChange={this.props.ua_yearOnchange} options={this.props.state.year_Calculation} isSearchable={false} placeholder="YYYY" />
                  </aside>
                </aside>
              )}
            </aside>
          </aside>
          <aside className="form-group">
            <aside className="form-inner">
              <Select
                value={this.props.state.ua_cinemaSelectValue}
                onChange={this.props.ua_cinemaOnchange}
                options={this.props.state.signup_PLDropdown}
                isSearchable={false}
                // placeholder="Preferred Location*"
                placeholder={this.props.state.loginAPI != "" ? (this.props.state.withOut_PLName != "" ? this.props.state.withOut_PLName : "Preferred Location*") : "Preferred Location*"}
                // menuIsOpen={this.state.menuIsOpen}
              />
            </aside>
          </aside>
          <aside className="form-group birthday-blk">
            <aside className="form-inner">
              <aside className="lft">
                <p>Anniversary</p>
              </aside>
              {this.props.state.loginAPI != "" && this.props.state.loginAPI.additionaldetails.anniversaryDate != null ? (
                <aside className="rgt readonly-anniversary">
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="MM*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.anniversaryDate.split("/")[0]} readOnly />
                    </aside>
                  </aside>
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="DD*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.anniversaryDate.split("/")[1]} readOnly />
                    </aside>
                  </aside>
                  <aside className="form-group">
                    <aside className="form-inner">
                      <input type="text" placeholder="YYYY*" autoComplete="off" value={this.props.state.loginAPI.additionaldetails.anniversaryDate.split("/")[2]} readOnly />
                    </aside>
                  </aside>
                </aside>
              ) : (
                <aside className="rgt">
                  <aside className="month-dropdown">
                    <Select value={this.props.state.an_monthSelectValue} onChange={this.props.ua_an_monthOnchange} options={this.props.an_month} isSearchable={false} placeholder="MM" />
                  </aside>
                  <aside className="date-dropdown">
                    <Select value={this.props.state.an_dateSelectValue} onChange={this.props.ua_an_dateOnchange} options={this.props.an_date} isSearchable={false} placeholder="DD" />
                  </aside>
                  <aside className="year-dropdown">
                    <Select value={this.props.state.an_yearSelectValue} onChange={this.props.ua_an_yearOnchange} options={this.props.state.year_Calculation} isSearchable={false} placeholder="YYYY" />
                  </aside>
                </aside>
              )}
            </aside>
          </aside>
        </section>
        {/* Personal form > end */}

        {/* Thearte > start */}
        <section className="theatre-blk">
          <section className="p-head">
            <h2>
              Theatre visits <span>* Required</span>
            </h2>
          </section>
          <section className="visit-list">
            <ul>
              <li>
                <aside className="lft">
                  <p>How many times have you gone to a movie theatre in the past year?*</p>
                </aside>
                <aside className="rgt">
                  <aside className="plus-minus-blk iczActive">
                    <a onClick={(e) => this.props.ua_counterBtnClick(e, "minus", "movieVisits")} className="minus-btn icControl iccDecrement disabled" href="javascript:;" title="-">
                      &nbsp;
                    </a>
                    <input className="input-field" type="text" defaultValue="0" readOnly />
                    <a onClick={(e) => this.props.ua_counterBtnClick(e, "plus", "movieVisits")} className="plus-btn icControl iccIncrement" href="javascript:;" title="+">
                      &nbsp;
                    </a>
                  </aside>
                </aside>
              </li>
              <li>
                <aside className="lft">
                  <p>Of those times how many of them were to a CMX / Cobb / CineBistro location?*</p>
                </aside>
                <aside className="rgt">
                  <aside className="plus-minus-blk iczActive">
                    <a onClick={(e) => this.props.ua_counterBtnClick(e, "minus", "CMXVisits")} className="minus-btn icControl iccDecrement disabled" href="javascript:;" title="-">
                      &nbsp;
                    </a>
                    <input className="input-field" type="text" defaultValue="0" readOnly />
                    <a onClick={(e) => this.props.ua_counterBtnClick(e, "plus", "CMXVisits")} className="plus-btn icControl iccIncrement" href="javascript:;" title="+">
                      &nbsp;
                    </a>
                  </aside>
                </aside>
              </li>
            </ul>
          </section>
          <section className="accept-blk">
            {this.props.state.withOut_MMRBtnTCSH && (
              <>
                <aside className="form-group" id="withoutMMR">
                  {this.props.state.loginAPI != "" && this.props.state.loginAPI.additionaldetails.agreetermscondition == true ? (
                    <input onChange={this.props.tc_AcceptClick} type="checkbox" id="accept-input" defaultChecked />
                  ) : (
                    <input onChange={this.props.tc_AcceptClick} type="checkbox" id="accept-input" />
                  )}
                  <label htmlFor="accept-input">
                    <p>
                      I accept to the{" "}
                      <a onClick={(e) => this.props.TandC_componentClick(e, "useraccount")} href="javascript:;" title="CMX Cinemas Terms &amp; Conditions">
                        CMX Cinemas Terms &amp; Conditions
                      </a>
                    </p>
                    <span className="check-btn">&nbsp;</span>
                    <p className="error-msg">{this.props.state.tcErrorMsg}</p>
                  </label>
                </aside>
                <aside className="form-group">
                  {this.props.state.loginAPI != "" && this.props.state.loginAPI.additionaldetails.sendpromotionsmails == true ? (
                    <input onChange={this.props.tc_AgreeClick} type="checkbox" id="agree-input" defaultChecked />
                  ) : (
                    <input onChange={this.props.tc_AgreeClick} type="checkbox" id="agree-input" defaultChecked />
                  )}

                  <label htmlFor="agree-input">
                    <p>
                      Yes, I agree I want to receive news, offers, promotions, and invites to special screenings. I have read the{" "}
                      <Link exact to={"/privacy-policy"} title="Privacy Policy">
                        Privacy Policy
                      </Link>{" "}
                      and understand I can withdraw my consent at any time.1
                    </p>
                    <span className="check-btn">&nbsp;</span>
                  </label>
                </aside>
                <aside className="cmx-flex-btn-group text-start">
                  {/* <a onClick={this.props.otp_ModalClick} className="flex-btn" href="javascript:;" title="SIGN UP"><span>SIGN UP</span></a> */}
                  <a onClick={this.props.withoutMMR_signupBtn} className={`flex-btn ${this.props.withoutMMR_signupDisabled() ? "disabled" : ""}`} href="javascript:;" title="SIGN UP">
                    <span>SIGN UP</span>
                  </a>
                </aside>
              </>
            )}

            {this.props.state.register_BtnTCSH && (
              <>
                <aside className="form-group" id="register">
                  <input onChange={this.props.tc_AcceptClick} type="checkbox" id="accept-input" defaultChecked />
                  <label htmlFor="accept-input">
                    <p>
                      I accept to the{" "}
                      <a onClick={(e) => this.props.TandC_componentClick(e, "useraccount")} href="javascript:;" title="CMX Cinemas Terms &amp; Conditions">
                        CMX Cinemas Terms &amp; Conditions
                      </a>
                    </p>
                    <span className="check-btn">&nbsp;</span>
                    <p className="error-msg">{this.props.state.tcErrorMsg}</p>
                  </label>
                </aside>
                <aside className="form-group">
                  <input onChange={this.props.tc_AgreeClick} type="checkbox" id="agree-input" defaultChecked />
                  <label htmlFor="agree-input">
                    <p>
                      Yes, I agree I want to receive news, offers, promotions, and invites to special screenings. I have read the{" "}
                      <Link exact to={"/privacy-policy"} title="Privacy Policy">
                        Privacy Policy
                      </Link>{" "}
                      and understand I can withdraw my consent at any time.2
                    </p>
                    <span className="check-btn">&nbsp;</span>
                  </label>
                </aside>
                <aside className="cmx-flex-btn-group text-start">
                  <a onClick={this.props.otp_ModalClick} className={`flex-btn ${this.props.signupBtnDisabled() ? "disabled" : ""}`} href="javascript:;" title="SIGN UP">
                    <span>SIGN UP</span>
                  </a>
                </aside>
              </>
            )}
          </section>
        </section>
        {/* Thearte > end */}
      </section>
    );
  }
}

export default PersonalDetails;
